export const state = {
    editedItem: {},
    expand: {
        expandSecao: false,
        expandSubsecao: false,
        expandPrateleira: false,
    },
    errorStatus: {
        hasError: false,
        errorMessage: [],
        status: null,
    },
    taxonomiaCategorias: [],
    categoriasSelected: [],
    imgAlta: null,
    loadingProdutos: false,
    produtosResponse: { content: [] },
    produtoCategoriaChanged: false,

    // 
    categoriaSemSegmento: false,
    categoriaDetails: {},
}

export const mutations = {
    SET_EDITED_ITEM(state, payload) {
        state.editedItem = payload
    },
    SET_EXPAND(state) {
        if (!state.expand.expandSecao) {
            state.expand.expandSecao = true
        } else if (!state.expand.expandSubsecao) {
            state.expand.expandSubsecao = true
        }
    },
    SET_RETRACT(state) {
        if (state.expand.expandSubsecao) {
            state.expand.expandSubsecao = false
        } else if (state.expand.expandSecao) {
            state.expand.expandSecao = false
        }
    },
    SET_ERROR_STATUS(state, error) {
        state.errorStatus.hasError = true;
        if (error.response) {
            state.errorStatus.errorMessage = error.response.data.errors
                ? error.response.data.errors
                : [error.response.data];
            state.errorStatus.status = error.response.status;
        } else {
            state.errorStatus.errorMessage = [error];
        }
    },
    SET_TAXONOMIA_CATEGORIAS(state, payload) {
        state.taxonomiaCategorias = payload
    },
    SET_CLEAN_ERROR(state) {
        state.errorStatus = {
            hasError: false,
            errorMessage: [],
            status: null,
        }
    },
    SET_CATEGORIAS_SELECTED(state, payload) {
        if (Array.isArray(payload)) {
            state.categoriasSelected = payload
            return
        }

        const index = state.categoriasSelected.findIndex(
            (c) => c.idCategoria === payload.idCategoria
        );
        if (index >= 0) {
            state.categoriasSelected.splice(index, 1);
        } else {
            state.categoriasSelected.push(payload);
        }
    },
    SET_IMG_ALTA(state, payload) {
        state.imgAlta = payload
    },
    SET_LOADING_PRODUTOS(state, payload) {
        state.loadingProdutos = payload
    },
    SET_PRODUTOS_RESPONSE(state, payload) {
        state.produtosResponse = payload
    },
    SET_PRODUTO_CATEGORIA_CHANGED(state, payload) {
        state.produtoCategoriaChanged = payload
    },

    // 
    SET_CATEGORIA_SEM_SEGMENTO(state, payload) {
        state.categoriaSemSegmento = payload
    },
    SET_CATEGORIA_DETAILS(state, payload) {
        state.categoriaDetails = payload
    },
}

export const actions = {
    changeEditedItem({ commit }, payload) {
        commit('SET_EDITED_ITEM', payload)
    },
    changeExpand({ commit }) {
        commit('SET_EXPAND')
    },
    changeRetract({ commit }) {
        commit('SET_RETRACT')
    },
    changeErrorStatus({ commit }, error) {
        commit('SET_ERROR_STATUS', error)
    },
    cleanError({ commit }) {
        commit('SET_CLEAN_ERROR')
    },
    changeTaxonomiaCategorias({ commit }, payload) {
        commit('SET_TAXONOMIA_CATEGORIAS', payload)
    },
    changeCategoriasSelected({ commit }, payload) {
        commit('SET_CATEGORIAS_SELECTED', payload)
    },
    changeImgAlta({ commit }, payload) {
        commit('SET_IMG_ALTA', payload)
    },
    changeLoadingProdutos({ commit }, payload) {
        commit('SET_LOADING_PRODUTOS', payload)
    },
    changeProdutosResponse({ commit }, payload) {
        commit('SET_PRODUTOS_RESPONSE', payload)
    },
    changeProdutoCategoriaChanged({ commit }, payload) {
        commit('SET_PRODUTO_CATEGORIA_CHANGED', payload)
    },

    // 
    changeCategoriaSemSegmento({commit}, payload) {
        commit('SET_CATEGORIA_SEM_SEGMENTO', payload)
    },
    changeCategoriaDetails({commit}, payload) {
        commit('SET_CATEGORIA_DETAILS', payload)
    },
}
